import { gql } from '@apollo/client'

const adminQuoteDetailsModelConfiguration = gql`
    fragment adminQuoteDetailsModelConfiguration on ModelConfiguration {
        id
        dfmInspection {
            id
        }
        process {
            id
            name
            platformProcessTypeId
        }
        material {
            ... on Material {
                id
                name
            }
            ... on UserEnteredMaterial {
                id
                name
                process {
                    id
                    name
                }
            }
        }
        materialGrade
        color {
            id
            name
        }
        colorCode
        shore {
            id
            name
        }
        texture {
            id
            name
        }
        textureCode
        dfmInspection {
            id
            manualOverrideMpUnitPayout
            manualOverrideUnitAmount
            manualOverrideUnitProductionDays
            inspectionData
        }
        productionLeadTime {
            id
            priorityId
            productionDays
            shipDateEstimate {
                id
                validUntilDate
                shippedByDate
            }
        }
        quantity
        requiresOvermold
        additionalRequirements
        userNeedsConfigHelp
        fdmInfillPercentageCategory
        fdmInfillPercentageCategoryLabel
    }
`

export default {
    adminQuoteDetailsModelConfiguration,
}
